export const en = {
    'add-button': 'Add',
    'cancel-button': 'Cancel',
    'select-campaigns': 'Select campaign',
    'select-campaigns-and-groups': 'Select campaign and ad group'
};
